import React from 'react';
import './payment-method-list.scss';
import {
  CommonButton,
  EmptyStateView,
  HeaderCard,
  ListSkeleton,
} from '../../components';
import { ReactComponent as InputInfo } from '@zonofi/svg-icons/input-info.svg';
import { PaymentMethodsCard } from './payment-methods-card';
import { usePaymentMethods } from '../hooks';
import { upperCase } from 'lodash';
interface PaymentMethodsListProps {
  onSendPaymentRequest: (
    selectedMethods: Record<string, string | null>
  ) => void;
  showLoading?: boolean;
}

export const PaymentMethodsList: React.FC<PaymentMethodsListProps> = ({
  onSendPaymentRequest,
  showLoading,
}) => {
  const {
    paymentMethodData,
    isLoading,
    onPaymentAccountPress,
    isPaymentAccountSelected,
    selectedMethods,
  } = usePaymentMethods();

  return (
    <div className="payment-method-list">
      <HeaderCard
        title={upperCase('Receive Payment To')}
        subtitle={'Receive funds via UPI, bank account, or both'}
      />

      <div className="payment-method-list-container">
        <span className="payment-method-list-container--title font-semibold">
          {'UPI &  BANK ACCOUNTS'}
        </span>

        <div className="payment-method-list-container--view">
          <InputInfo color="#000000" />
          <span className="payment-method-list-container--view-text font-regular">
            {'You can select only one UPI and one bank account.'}
          </span>
        </div>

        {isLoading ? (
          <ListSkeleton height={50} className="list-skeleton-view" />
        ) : paymentMethodData.length === 0 ? (
          <EmptyStateView message={'NO UPI OR BANK FOUND'} />
        ) : (
          paymentMethodData.map((item, index) => (
            <PaymentMethodsCard
              key={`${item.id}-${index}`}
              item={item}
              isLast={index === paymentMethodData.length - 1}
              onPress={onPaymentAccountPress}
              isSelected={isPaymentAccountSelected(item)}
            />
          ))
        )}
      </div>
      {Object.keys(selectedMethods).length > 0 && (
        <div className="view-payment-request-footer">
          <CommonButton
            text={'Send Payment Request'}
            onPress={() => onSendPaymentRequest(selectedMethods)}
            loading={showLoading}
            spinnerColor={'white'}
          />
        </div>
      )}
    </div>
  );
};
